import { SpinnerWrapper } from '@repo/ui/components/Icon';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Card = styled(FlexColumn)`
  padding: 24px;
  background: ${themeStyle.varBackgroundAlt};
  border-radius: ${themeStyle.radiusLarge};
  box-shadow: ${themeStyle.shadowSoft};
`;

export const CenteredImageWrapper = styled(FlexColumn)`
  position: relative;

  align-items: center;
  justify-content: center;

  width: 100%;

  aspect-ratio: 1 / 1;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;

  flex-grow: 1;
  object-fit: contain;
`;

export const CenteredSpinnerWrapper = styled(SpinnerWrapper)`
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;
